import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { map, path, is, addIndex, identity } from 'ramda';
import { List } from './inlineList.styles';
import { EntityRefData } from '../../../../shared/components/entityRefData';
import { ExperiencesListItem } from '../../experiencesListItem';
import { experiencePropType } from '../../../../propTypes';

export class InlineList extends PureComponent {
  static propTypes = {
    experiences: PropTypes.arrayOf(experiencePropType),
    placeholder: PropTypes.bool,
    indexModifier: PropTypes.func,
  };

  static defaultProps = {
    indexModifier: identity,
  };

  static getHeroImage = experience => path(['heroGallery', 0], experience);

  static hasFileObject = experience => {
    const heroImage = InlineList.getHeroImage(experience);
    return !is(String, heroImage);
  };

  placeholders = [{ id: 1, ratio: 1 }, { id: 2, ratio: 1.5 }, { id: 3, ratio: 1.25 }];

  renderItem = (experience, index) => {
    const heroImage = InlineList.getHeroImage(experience);
    const modifiedIndex = this.props.indexModifier(index);

    if (InlineList.hasFileObject(experience)) {
      return (
        <ExperiencesListItem
          index={index}
          key={experience.id}
          placeholder={this.props.placeholder}
          experience={experience}
          file={path(['fields', 'file'], heroImage)}
        />
      );
    }

    return (
      <EntityRefData key={experience.id} id={heroImage}>
        {({ file } = {}) => (
          <ExperiencesListItem
            index={modifiedIndex}
            placeholder={this.props.placeholder}
            experience={experience}
            file={file}
          />
        )}
      </EntityRefData>
    );
  };

  render() {
    return (
      <List>{addIndex(map)(this.renderItem, this.props.placeholder ? this.placeholders : this.props.experiences)}</List>
    );
  }
}
